import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Waypoint from 'react-waypoint'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { Link } from 'react-router-dom'

import Filter from './Filter'
import Project from './Project'
import Hiring from './Hiring'

import './grid.css'

class Grid extends Component {
  constructor (props) {
    super(props)
    this.blocks = this.props.blocks || []

    this.state = {
      filter: -1,
      blocks: this.blocks ? this.blocks.slice(0, 4) : [],
      showMoreBlocks: this.props.showMoreBlocks || 4
    }

    // Parse the filters data
    this.filters = {
      [-1]: {id: -1, name: 'All', count: this.blocks.length}
    }

    this.filterKey = this.props.filterKey
    this.blocks.forEach(block => {
      // If the Grid is filterable, populate filter
      const cats = block[this.filterKey]
      if (this.filterKey && cats) {
        cats.forEach(cat => {
          if (!this.filters[cat.id]) {
            this.filters[cat.id] = {
              ...cat
            }
          }
        })
      }
    })

    this.showMore = this.showMore.bind(this)
    this.getMoreBlocks = this.getMoreBlocks.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onShowMoreEnter = this.onShowMoreEnter.bind(this)
  }

  onShowMoreEnter (current, previous) {
    // Load more blocks if the 'See more' button is inside the viewport
    if (current.currentPosition === 'inside') {
      this.setState(this.getMoreBlocks())
    }
  }

  getMoreBlocks () {
    const filter = this.state.filter
    const displayBlocks = this.state.blocks.length + this.state.showMoreBlocks
    let blocks = this.blocks

    if (filter !== -1) { // Filter through current category
      blocks = this.blocks.filter(block => {
        // Return the block only if the category was found
        return block.categories.filter(cat => {
          return cat.id === filter
        }).length
      })
    }

    return {
      displayBlocks,
      blocks: blocks.slice(0, displayBlocks)
    }
  }

  showMore () {
    this.setState(this.getMoreBlocks())
  }

  onFilterChange (newVal) {
    this.setState({
      filter: newVal.id,
      blocks: []
    })

    // Trigger re-render transitions
    setTimeout(() => {
      this.setState(this.getMoreBlocks())
    }, 400)
  }

  render () {
    if (!this.blocks) {
      return false
    }

    const filters = this.filters
    const filterKey = this.filterKey
    const blocks = this.state.blocks.map((block, idx) => {
      const cats = !filterKey ? false : block[filterKey] || false
      const filterIds = (!filterKey && !cats) || !cats ? false : cats.map(cat => cat.id)

      return (
        <CSSTransition
          key={idx}
          timeout={500}
          classNames='fade'
        >
          <Block
            data={block}
            type={block.type}
            currentFilterId={this.state.filter}
            filterIds={filterIds}
          />
        </CSSTransition>
      )
    })

    const filter = !filterKey ? false : (
      <Filter
        onFilterChange={this.onFilterChange}
        filters={{
          ...filters
        }}
      />
    )

    // Show 'See More' button only if the current blocks length
    // Is less than filter (category) count
    const showMore = this.state.blocks.length >= this.filters[this.state.filter].count && !this.props.showProjectsLink ? false : (
      <Link to='projects' className='grid__more' onClick={this.showMore}>
        <Waypoint onPositionChange={this.onShowMoreEnter} bottomOffset='-1px' />
        — See More —
      </Link>
    )

    return (
      <div className='container-fluid'>
        { filter }
        <div className='grid__wrapper'>
          <TransitionGroup className='grid'>
            { blocks }
          </TransitionGroup>
          { showMore }
        </div>
      </div>
    )
  }
}

const Block = (props) => {
  if (props.type === 'hiring') {
    return (
      <Hiring
        label={props.data.label}
        title={props.data.title}
        subtitle={props.data.subtitle}
        description={props.data.description}
        cta_text={props.data.cta_text}
        cta_link={props.data.cta_link}
      />
    )
  }
  if (props.type === 'project') {
    return (
      <Project
        url={props.data.url}
        label={props.data.label}
        img={props.data.img}
        title={props.data.title}
        subtitle={props.data.subtitle}
        tags={props.data.tags}
        description={props.data.description}
      />
    )
  }
}

Block.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
}

Grid.propTypes = {
  showProjectsLink: PropTypes.bool,
  blocks: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  filterKey: PropTypes.string
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/Grid/index.js